module.exports = __webpack_public_path__ + "static/media/sc19.24.8726bd24.mp4";